/**
 * Handles silencing multi user GTM V2 entry points *
 */ export var MULTI_USER_GTM_PDP_AND_BRAND_PAGE_V2_SILENCING = 'MULTI_USER_GTM_PDP_AND_BRAND_PAGE_V2_SILENCING';
